import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

/**
 * The one RTK Query api every app and package injects endpoints into.
 *
 * It lives here, not in the apps, so entities can call
 * `baseApi.injectEndpoints(...)` at import time and get fully typed hooks.
 * Apps add `baseApi` to `combineSlices` and `baseApi.middleware` to the store.
 */
export const baseApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: '/',
        prepareHeaders: (headers, { getState, endpoint }) => {
            if (endpoint !== 'postLogin') {
                const token = (getState() as { authSlice?: { jwt?: string } })
                    .authSlice?.jwt;

                if (token) {
                    headers.set('Authorization', `bearer ${token}`);
                }
            }

            return headers;
        },
    }),
    endpoints: () => ({}),
});
